const UNITS = [
  ['year', 31536000],
  ['month', 2592000],
  ['week', 604800],
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60],
]

export function timeAgo (timestamp) {
  if (!timestamp) {
    return ''
  }

  const date = timestamp instanceof Date ? timestamp : new Date(timestamp)
  if (isNaN(date.getTime())) {
    return ''
  }

  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  const unit = UNITS.find(([, size]) => seconds >= size)
  if (!unit) {
    return 'just now'
  }

  const [name, size] = unit
  const value = Math.floor(seconds / size)

  return `${value} ${name}${value === 1 ? '' : 's'} ago`
}
